'use strict';

module.exports = Object.freeze(
  Object.keys(require('./communication_channel_titles'))
);
